<template>
    <div>
        <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
            <PulseLoader :loading="loading"></PulseLoader>
        </div>
        <div v-if="!loading">
            <div class="row">
                <div class="col-md-12 col-sm-12 ">
                    <div class="">
                        <div class="x_panel">
                            <h2 class="float-left">SCE Master List</h2>
                            <ul class="nav navbar-right panel_toolbox align-right">
                                <li v-if="isPermissionExist(PERMISSIONS.SCE_LIST_CREATE)">
                                    <button type="button" class="btn btn-info btn-sm" @click="create">Add New <i class="fa fa-plus"></i></button>
                                </li>
                                <li>
                                    <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                                </li>
                            </ul>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="card-box table-responsive">
                                            <p class="text-muted font-13 m-b-30"></p>
                                            <table id="datatables" class="table table-striped table-bordered table-sm  text-center" style="width:100%">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Hardware Barrier</th>
                                                    <th>Element</th>
                                                    <th>Code</th>
                                                    <th>Action</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(sce , index) in sceData" :key="sce.id">
                                                    <td>{{index+1}}</td>
                                                    <td>{{sce?.category_name}}</td>
                                                    <td>{{sce.name}}</td>
                                                    <td>{{sce.code}}</td>
                                                    <td>
                                                        <button v-if="isPermissionExist(PERMISSIONS.SCE_LIST_EDIT)" title="Edit Job Type" type="button" @click="edit(sce)" class="btn btn-primary btn-sm">
                                                            <i class="fa fa-edit"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="roleModal" tabindex="-1" role="dialog" aria-labelledby="customerModalLongTitle" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="customerModalLongTitle">{{ editMode ? 'Edit' : 'Add New' }} Element</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form @submit.prevent="editMode ? update() : store()" @keydown="form.onKeydown($event)">
                            <div class="modal-body">
                                <div class="form-group">
                                    <label>Hardware Barrier</label>
                                    <select v-model="form.category_id" name="hardware_barrier" class="form-control" :class="{ 'is-invalid': form.errors.has('hardware_barrier') }">
                                        <option value="">Select Hardware Barrier</option>
                                        <option v-for="category in sceCategories" :key="category.id" :value="category.id">{{category.name}}</option>
                                    </select>
                                    <has-error :form="form" field="hardware_barrier"></has-error>
                                </div>
                                <div class="form-group">
                                    <label>Element Name</label>
                                    <input v-model="form.name" type="text" name="element_name" class="form-control" :class="{ 'is-invalid': form.errors.has('element_name') }" autocomplete="off">
                                    <has-error :form="form" field="element_name"></has-error>
                                </div>
                                <div class="form-group">
                                    <label>Element Code</label>
                                    <input v-model="form.code" type="text" name="element_code" class="form-control" :class="{ 'is-invalid': form.errors.has('element_code') }" autocomplete="off">
                                    <has-error :form="form" field="element_code"></has-error>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button :disabled="form.busy" type="submit" class="btn btn-info">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- Modal -->

        </div>
    </div>
</template>

<script>
    import auth from '../../auth'
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import PermissionsMixin from "@/mixin/permissionsMixin";

    export default {
        mixins: [goBackButtonMixin, PermissionsMixin],
        name: 'SceElements',
        components: {PulseLoader},
        data() {
            return {
                loading: false,
                editMode: false,
                permissions: auth.getPermissionData(),
                query: '',
                queryFiled: 'name',
                sceData: [],
                sceCategories: [],
                form: new Form({
                    id: '',
                    category_id: '',
                    name: '',
                    code: ''
                }),
                pagination: {
                    current_page: 1
                }
            }
        },
        mounted() {
            this.getData();
            this.getCategories()
        },
        methods: {
            getData() {
                this.loading = true;
                this.$http.get('/api/sce-elements').then(response => {
                    this.sceData = response.data.success;
                    this.loading = false;
                    setTimeout(() => $('#datatables').DataTable(), 1000)
                }).catch(e => {
                    this.loading = false;
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },
            getCategories() {
                this.$http.get('/api/sce-categories').then(response => {
                    this.sceCategories = response.data;
                }).catch(e => {
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                });
            },
            create() {
                this.editMode = false;
                this.form.reset();
                this.form.clear();
                $('#roleModal').modal('show')
            },
            store() {
                this.form.busy = true;
                this.form.post('/api/sce-elements').then(response => {
                    $('.dataTables_empty').closest('tr').remove();
                    this.getData();
                    $('#roleModal').modal('hide');
                    if (this.form.successful) {
                        this.$snotify.success('Safety Critical Element(SCE) created successfully')
                    } else {
                        this.$snotify.error('Something went wrong try again later.')
                    }
                }).catch(e => {
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else if (response.status === 422) {
                        if (e.response.data?.errors) {
                            const errors = e.response.data?.errors;
                            for (const key in errors) {
                                this.$snotify.error(errors[key][0])
                            }
                        }
                    } else {
                        this.$snotify.error(response?.data?.error)
                    }
                });
            },
            edit(type) {
                this.editMode = true;
                this.form.reset();
                this.form.clear();
                this.form.fill(type);
                $('#roleModal').modal('show');
            },
            update() {
                this.form.busy = true;
                this.form._method = 'put';
                this.form.post('/api/sce-elements/' + this.form.id).then(response => {
                    this.getData();
                    $('#roleModal').modal('hide');
                    if (this.form.successful) {
                        this.$snotify.success('Safety Critical Element(SCE) updated successfully')
                    } else {
                        this.$snotify.error('Something went wrong try again later.', 'Error')
                    }
                }).catch(e => {
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else if (response.status === 422) {
                        if (e.response.data?.errors) {
                            const errors = e.response.data?.errors;
                            for (const key in errors) {
                                this.$snotify.error(errors[key][0])
                            }
                        }
                    } else {
                        this.$snotify.error(response?.data?.error)
                    }
                })
            },
            goBack() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
